/* src/app/webhook-creator/webhook-creator/webhook-edit/webhook-ia-assistant/webhook-ia-assistant.component.scss */
.ia-prompt-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  min-height: 0;
}
.ia-textarea {
  margin-top: 12px;
  width: 100%;
  font-size: 14px;
}
.ia-actions {
  margin-top: 12px;
  text-align: right;
}
.ia-response {
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  overflow: auto;
  padding: 10px;
}
.response-item {
  max-width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
  position: relative;
  width: 100%;
}
.user-question {
  max-width: 90%;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  position: relative;
}
.left {
  align-self: flex-start;
  background-color: var(--tem-surface-2);
  border-left: 3px solid var(--tem-deep);
}
.right {
  align-self: flex-end;
  background-color: var(--tem-accent-soft);
  border-right: 3px solid var(--tem-accent);
}
.feedback {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
}
.ia-loading {
  text-align: center;
  margin: 12px 0;
}
.loading-gif {
  width: 32px;
  height: 32px;
}
.ia-input-area {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;
  align-items: center;
}
.ia-prompt-card-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
p {
  width: 95%;
}
.spin-ia {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
:ng-deep .ant-spin-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
/*# sourceMappingURL=webhook-ia-assistant.component.css.map */
